<template>
  <div>
    <v-text-field 
      v-bind="$attrs" 
      v-money="money"
      :value="formattedValue"
      @input="handleInput" />
  </div>
</template>
   
<script>
import { VMoney } from 'v-money'
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined || this.value === '') {
        return '';
      }
      const numValue = typeof this.value === 'string' ? parseFloat(this.value.replace(/[^\d,.-]/g, '').replace(',', '.')) : this.value;
      if (isNaN(numValue)) {
        return '';
      }
      return numValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  methods: {
    handleInput(v) {
      if (!v || v === '') {
        this.$emit('input', '');
        return;
      }
      const numericValue = v.replaceAll('.', '').replace(',', '.');
      const floatValue = parseFloat(numericValue);
      if (!isNaN(floatValue)) {
        this.$emit('input', floatValue);
      } else {
        this.$emit('input', '');
      }
    }
  },
  directives: { money: VMoney }

}
</script> 